import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { CONFIG } from '../../common/constants';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private systemUrl = `${environment.apiBaseUrl}/system`; // URL to web api
  private usuarioUrl = `${environment.apiBaseUrl}/usuarios`; // URL to web api

  constructor(public http: HttpClient) { }

  private handleErrorNothing<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: enviar el error a la infraestructura de registro remoto
      // console.error(error); // log to console instead

      // TODO: mejor trabajo de transformación de error para el consumo del usuario.
      console.log(`CommonService: ${operation} failed: ${error.message}`);

      // Deja que la aplicación siga funcionando devolviendo un resultado vacío.
      return of(result as T);
    };
  }

  public getListadoComboGenero(): Observable<any[]> {
    return this.http.get<any[]>(`${this.systemUrl}/genero`).pipe(
      map(res => res['sexo']),
      catchError(this.handleErrorNothing('getListadoComboGenero', []))
    );
  }

  public getListadoComboPerfil(): Observable<any[]> {
    return this.http.get<any[]>(`${this.usuarioUrl}/combo/perfiles`).pipe(
      map(res => res['perfiles']),
      catchError(this.handleErrorNothing('getListadoComboPerfil', []))
    );
  }

}

